import { useState, useEffect } from 'react';
import i18n from '@/i18n';

const LANG_KEY = 'helios_lang';

const LANG_MAP: Record<string, string> = {
  UA: 'uk',
  PL: 'pl',
  EN: 'en',
};

export function useLanguage() {
  const stored = localStorage.getItem(LANG_KEY) ?? 'UA';
  const [language, setLanguageState] = useState<string>(stored);

  useEffect(() => {
    const i18nLang = LANG_MAP[language] ?? 'uk';
    i18n.changeLanguage(i18nLang);
  }, [language]);

  const setLanguage = (lang: string) => {
    localStorage.setItem(LANG_KEY, lang);
    setLanguageState(lang);
    const i18nLang = LANG_MAP[lang] ?? 'uk';
    i18n.changeLanguage(i18nLang);
  };

  return { language, setLanguage };
}
